import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "content"]
  static values = { activeTab: String }

  connect() {
    this.showTab(this.activeTabValue || "details")
  }

  switchTab(event) {
    event.preventDefault()
    const tabName = event.currentTarget.dataset.tab
    this.showTab(tabName)
  }

  showTab(tabName) {
    // Hide all tab contents
    this.contentTargets.forEach(content => {
      content.classList.add("hidden")
    })

    // Remove active class from all tabs
    this.tabTargets.forEach(tab => {
      tab.classList.remove("active")
    })

    // Show selected tab content
    const selectedContent = this.contentTargets.find(content => 
      content.id === `${tabName}-tab`
    )
    if (selectedContent) {
      selectedContent.classList.remove("hidden")
    }

    // Add active class to selected tab
    const selectedTab = this.tabTargets.find(tab => 
      tab.dataset.tab === tabName
    )
    if (selectedTab) {
      selectedTab.classList.add("active")
    }

    this.activeTabValue = tabName
  }
}
